import { useMutation } from "@tanstack/react-query";
import { OrdersService } from "@/services/orders/orders-service";
import type { CreateOrderRequest, CreateOrderResponse } from "@/services/orders/orders.types";

const ordersService = new OrdersService();

/**
 * React Query mutation for submitting a hardware order. Mirrors the pattern
 * used by useHardwareCatalog (useQuery wrapper around a service call) but for
 * a write operation.
 */
export const useCreateOrder = () => {
  return useMutation<CreateOrderResponse, Error, CreateOrderRequest>({
    mutationFn: (request) => ordersService.createOrder(request),
  });
};
